/**
 * The count doubles as the disclosure that something is hidden: with the
 * switch off, nothing else on the screen would tell an admin that disabled
 * items exist at all.
 */
export function buildListCountLabel({
  visible,
  disabled,
  showDisabled,
  noun,
}: {
  /** How many rows the table is showing. */
  visible: number;
  /** How many disabled items match the search, shown or not. */
  disabled: number;
  showDisabled: boolean;
  /** Masculine singular and plural, e.g. `["prodotto", "prodotti"]`. */
  noun: [string, string];
}): string {
  const pick = (count: number, [one, many]: [string, string]): string =>
    count === 1 ? one : many;

  if (disabled === 0) {
    return `${visible} ${pick(visible, noun)} ${pick(visible, ["trovato", "trovati"])}`;
  }

  const tail = `${disabled} ${pick(disabled, ["disattivato", "disattivati"])}`;

  return showDisabled
    ? `${visible} ${pick(visible, noun)} · ${tail}`
    : `${visible} ${pick(visible, ["attivo", "attivi"])} · ${tail}`;
}
